var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _radialGradient, _path28, _path29, _path30, _radialGradient2, _path31;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLamp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.1 81.32c-.6.24-52.2.39-52.2.39s-1.02 6.57 2.98 15.1c2.7 5.75 7.07 13.65 12.75 18.35c3.46 2.86 10.84 9.29 29.55 9.41c20.38.13 28.12-9.18 32.53-13.35s10.61-12.99 15.13-17.4s9.41-7.39 9.77-11.56c.36-4.17-2.74-4.29-2.74-4.29L56.1 81.32z",
    fill: "#891e0d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.95 106.82c20.49-.82 27.29-8.1 40.99-16.33c11.74-7.04 16.21-9.65 16.21-11.44s-10.79-5.11-17.04-7.98c-8.82-4.05-21.81-11.8-44.69-11.92c-19.67-.1-40.56 7.87-40.56 23.12c.01 15.49 25.32 25.34 45.09 24.55z",
    fill: "#d75010"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.79 67.38l-9.91 2.34l-10.66 6.08l-1.17 6.82l1.81 2.98l66.29.96l9.06-6.29s-3.52-1.81-4.16-2.24c-.64-.43-24.3-8.42-24.62-8.31c-.32.11-26.64-2.34-26.64-2.34z",
    fill: "#fe9700"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.54 86.99s.85-3.75 5.33-7.14c4.37-3.3 11.34-6.55 25.21-5.89c12.77.61 22.32 5.03 26.9 8.02c4.58 2.98 7.99 5.44 7.99 5.44l-13.32 6.82l-16.52 4.16s-23.34-2.34-24.41-3.3c-1.06-.97-11.18-8.11-11.18-8.11z",
    fill: "#d85f11"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.07 93.72s-.07-.05-.18-.18c-.37-.46-1.24-3.11-.68-5.79c1.19-5.63 6.82-8.71 11.85-9.57c6.13-1.05 11.73-.94 11.73 3.44c0 3.52-4.94 3.18-7.39 3.41c-2.44.23-6.02.91-6.14 3.41c-.12 2.62 4.29 3.76 11.31 2.95c6.15-.71 15.1-3.8 15.1-3.8l3.43 4.37l-.4 3.13s-9.83 2.95-10.34 2.9c-.51-.06-17.84-.11-18.81-.57c-.96-.46-9.48-3.7-9.48-3.7z",
    fill: "#eba961"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2 99.26c-2.47 0-5.12-.12-8.02-.37c-13.89-1.2-30.17-8.17-27.98-18.06c1.93-8.72 13.68-14.91 32.82-14.95c20.26-.04 46.25 12.5 47.35 13.01c0 0 1.07.43 1.14 1.11c.07.75-.84 1.42-.84 1.42c-.32.26-8.02 6.39-19.13 11.89c-7.32 3.63-14.47 5.95-25.34 5.95zm-5.01-30.39c-16.75 0-27.39 6.03-27.82 12.4c-.53 7.83 12.67 13.56 25.07 14.63c15.03 1.3 23.03-.95 31.77-5.28c7.57-3.75 13.62-7.88 16.58-10.04c-6.84-2.97-27.61-11.39-43.83-11.7c-.59-.01-1.19-.01-1.77-.01z",
    fill: "#ffe36a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.67 87.58s6.38-2.51 10.58-4.5c4.05-1.92 11.45-6.37 11.45-6.37l6.78.81l3.02 2.49s-9.43 6.43-17.4 9.97c-6.61 2.94-12.61 4.2-12.61 4.2s-3.73-.02-3.83-3.17c-.06-2.21 2.01-3.43 2.01-3.43z",
    fill: "#fef499"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86 80.61c-.06 1.44 1.22 2.44 3.27 2.33c1.78-.1 3-.93 2.94-2.44c-.06-1.39-1.03-2.34-2.88-2.33c-2.11 0-3.27.98-3.33 2.44z",
    fill: "#ffa821"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.83 91.57c-1.33-.1-3.22.78-3.11 2.88s2.22 2.55 3.33 2.44c1.21-.12 2.59-.78 2.72-2.5c.11-1.43-.67-2.65-2.94-2.82z",
    fill: "#ffa821"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M34.12 99.27c-1.5-.02-3.24.89-3.24 2.68c0 1.62 1.47 2.61 3.49 2.64c1.96.03 3.19-1.14 3.15-2.71c-.02-1.11-.82-2.58-3.4-2.61z",
    fill: "#ffa821"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M55.31 99.95c-2.29.22-3.27 1.6-3.17 2.93c.1 1.33 1.29 2.5 3.52 2.28c2.62-.25 3.22-1.39 3.16-2.69s-1.08-2.75-3.51-2.52z",
    fill: "#ffa821"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.89 94.55c-1.58.72-2.25 2.24-1.5 3.55c.65 1.14 2.66 1.03 3.91.23c1.24-.8 1.92-1.97 1.24-3.31c-.59-1.15-2.15-1.15-3.65-.47z",
    fill: "#ffa821"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M85.99 89.64c.98 1.32 2.51.85 3.72-.03c1.18-.86 1.56-2.18.95-3.19c-.62-1.01-2.18-1.01-3.55-.1s-1.87 2.31-1.12 3.32z",
    fill: "#ffa821"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.81 81.61c.88.95 2.43.9 3.72.07c1.4-.91 1.63-2.22.75-2.84s-2.16-.64-3.42.03c-.73.39-1.96 1.76-1.05 2.74z",
    fill: "#ffa821"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.15 65.25c-.46 1.21-.26 2.64 2.02 3.19c2.28.55 3.21-.48 3.42-1.47c.26-1.21-.59-2.41-2.18-2.74c-1.6-.31-2.86-.03-3.26 1.02z",
    fill: "#ffa821"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 62.28c-.15 1.19.59 2.31 2.93 2.51s3.29-.63 3.37-2.09c.09-1.69-1.61-2.19-3.1-2.34c-1.57-.16-3.02.47-3.2 1.92z",
    fill: "#ffa821"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.19 63.49c.09 1.18 1.26 2.08 3.22 1.79c1.96-.29 2.77-1.27 2.56-2.56c-.21-1.28-1.52-1.93-3.07-1.8c-1.6.12-2.82 1.13-2.71 2.57z",
    fill: "#ffa821"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.81 66.62c-1.59.66-1.92 2.84-.65 3.59s2.97.73 4.2-.23c1.46-1.14 1.31-2.76.2-3.35c-1.19-.64-2.4-.57-3.75-.01z",
    fill: "#ffa821"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45 74.38c.34 1.22 1.43 1.83 3.35 1.42c1.75-.37 2.68-1.56 2.43-2.87c-.26-1.31-1.48-2.13-3.45-1.68c-1.92.44-2.65 1.99-2.33 3.13z",
    fill: "#91c354"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74 88.08c.08 1.6 1.36 2.56 2.92 2.56c1.63 0 2.95-1 2.91-2.59c-.05-1.71-1.21-2.44-2.93-2.48c-1.2-.02-3 .56-2.9 2.51z",
    fill: "#91c354"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.19 98.67c-.09 1.87 1.38 2.87 3.17 2.87s2.96-.88 3.05-2.67c.1-1.79-1.36-2.59-3.09-2.62c-1.72-.04-3.05.68-3.13 2.42z",
    fill: "#91c354"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M41.68 102.82c.06 1.5 1.38 2.49 3.33 2.55c1.99.07 3.47-.89 3.48-2.78c.01-1.52-1.4-2.55-3.52-2.55c-1.96 0-3.36 1.09-3.29 2.78z",
    fill: "#91c354"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M62.07 101.66c.53 1.51 2.22 1.76 4.17 1.08c1.96-.68 2.66-2.35 2.25-3.49c-.52-1.43-2.31-1.73-3.95-1.24c-1.63.49-3.12 1.79-2.47 3.65z",
    fill: "#91c354"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M80.37 90.47c-1.23.76-1.92 2.15-1.17 3.36s2.54.91 3.61.16c1.18-.82 1.99-2.18 1.08-3.39c-.98-1.29-2.57-.71-3.52-.13z",
    fill: "#91c354"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M92.86 82.66c-1.23.74-1.57 2.15-.78 3.12c.74.91 2.35.69 3.3.04c.95-.65 1.53-2.14.49-3.13c-.77-.74-2.02-.62-3.01-.03z",
    fill: "#91c354"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M73.92 67.48c-.72 1.47.26 2.74 1.63 3.26c1.37.52 2.61.03 3.03-.78s.16-2.31-1.6-3c-1.75-.69-2.77-.07-3.06.52z",
    fill: "#91c354"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M56.83 63.43c-.23 1.7.9 2.53 2.72 2.76c1.78.22 3.17-.28 3.43-1.86c.26-1.6-1.14-2.44-2.51-2.74c-1.38-.29-3.43.25-3.64 1.84z",
    fill: "#91c354"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M38.56 62.39c0 1.4 1.3 2.23 3.11 2.19c1.99-.04 3.07-.77 3.06-2.23c-.01-1.31-1.29-2.26-3.1-2.26c-1.86 0-3.07 1.04-3.07 2.3z",
    fill: "#91c354"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1 63.05c-2.37.47-2.23 2.13-1.89 2.98c.39.98 1.75 1.5 3.22 1.19c1.97-.41 2.64-1.83 2.18-2.87c-.54-1.24-1.94-1.61-3.51-1.3z",
    fill: "#91c354"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab7797",
    cx: 93.645,
    cy: 9.376,
    r: 57.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#ffcf18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#ffcc16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    stopColor: "#fec212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#fdb10a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.982,
    stopColor: "#fc9d00"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M93.71 8.97c-1.34 0-3.48 9.38-5.76 15.94c-2.28 6.56-8.74 23.44-10.58 31.62c-1.21 5.36-1.35 12.63 1.43 16.7c2.29 3.36 7.17 6.67 12.43 7.18c5.6.54 15.62-2.58 17.76-11.42c2.14-8.84-1.07-17.28-3.35-24.79c-1.82-6-5.09-14.74-6.7-20.1c-1.2-3.95-3.89-15.13-5.23-15.13z",
    fill: "url(#IconifyId17ecdb2904d178eab7797)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M87.34 71.14s-.79 1.68-1.53 2.72c-.93 1.31-2.79 3.36-2.79 3.36s.53.57 2.77 1.67c4.57 2.24 8.09 1.54 8.09 1.54s1.57-1.88 2.01-3.02s.22-3.92-3.16-5.61c-3.37-1.69-5.11-1.26-5.39-.66z",
    fill: "#ff7512"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M89.36 75.34s2.78-.11 4.09.33S96 76.81 96 76.81s.49-2.83-2.89-5.28s-5.45-.82-5.45-.82s.65 1.04.93 1.96c.28.92.77 2.67.77 2.67z",
    fill: "#ca750f"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab7798",
    cx: 91.377,
    cy: 51.143,
    r: 49.412,
    gradientTransform: "matrix(.0162 -.9999 .741 .012 52.002 141.895)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#ffd874"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd874",
    stopOpacity: 0
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M53.35 47.45c-1.92 26.39 6.83 55.92 40.17 54.81c33.33-1.11 34.71-27.2 34.3-52.81C127.42 24.33 122.71.99 94.7.32C70.24-.26 55.35 19.88 53.35 47.45z",
    opacity: 0.5,
    fill: "url(#IconifyId17ecdb2904d178eab7798)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.66dac99c23d74303ff960dbb557b431a.svg";
export { ForwardRef as ReactComponent };